import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { StarRow } from "@/components/StarRow";
import { api, errorMessage } from "@/lib/api";

export function AppReviewsAdmin() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/admin/app-reviews").then((r) => setReviews(r.data)).catch(() => {}); }, []);
  const hide = async (r, hidden) => {
    try { await api.patch(`/admin/app-reviews/${r.id}`, { hidden }); setReviews((xs) => xs.map((x) => (x.id === r.id ? { ...x, hidden } : x))); toast.success(hidden ? "Review hidden" : "Review visible"); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <section data-testid="admin-app-reviews" className="rounded-2xl bg-[#151C2C] border border-[#26334D] p-5">
      <h3 className="font-semibold flex items-center gap-2 mb-3"><Star className="h-4 w-4 text-[#FFB800]" /> App reviews</h3>
      {reviews.length === 0 && <p className="text-sm text-slate-500">No app ratings yet.</p>}
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {reviews.map((r) => (
          <div key={r.id} data-testid={`admin-app-review-${r.id}`} className={`rounded-xl border border-[#26334D] p-3 text-sm ${r.hidden ? "opacity-50" : ""}`}>
            <div className="flex items-center justify-between gap-3">
              <span className="font-semibold">{r.name} <StarRow value={r.rating} size="h-3 w-3" /></span>
              <label className="flex items-center gap-2 text-xs text-slate-400">Hide <Switch data-testid={`admin-app-review-hide-${r.id}`} checked={r.hidden} onCheckedChange={(on) => hide(r, on)} /></label>
            </div>
            {r.text && <p className="text-slate-300 mt-1">{r.text}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
